<template>
  <div class="flex flex-col p-2 bg-white rounded min-h-screen my-2">
    <div class="flex flex-col animate-pulse bg-gray-100 min-h-screen" v-if="loading"></div>
    <div class="flex flex-col flex-1" v-else>
      <div class="flex flex-col" v-if="task">
        <b-row v-if="task">
          <b-col>
            <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
              <thead class="text-md">
              <tr class="bg-gray-pale">
                <td colspan="12" class="px-2 py-2 font-bold">Application Details</td>
              </tr>
              </thead>
              <tbody class="text-xs">
              <tr style="border: solid 1px #dedede;">
                <td class="px-2 py-1 text-capitalize font-bold">Tracking Number</td>
                <td class="px-2 py-1 text-capitalize">{{ task.trackingNumber || 'N/A' }}</td>
              </tr>
              <tr style="border: solid 1px #dedede;">
                <td class="px-2 py-1 text-capitalize font-bold">Entity Name</td>
                <td class="px-2 py-1 text-capitalize">{{ task.name || 'N/A' }}</td>
              </tr>
              <tr v-if="task.interimErn" style="border: solid 1px #dedede;">
                <td class="px-2 py-1 text-capitalize font-bold">Interim ERN</td>
                <td class="px-2 py-1 text-capitalize text-blue">{{ task.interimErn || 'N/A' }}</td>
              </tr>
              <tr style="border: solid 1px #dedede;">
                <td class="px-2 py-1 text-capitalize font-bold">Type</td>
                <td class="px-2 py-1 text-capitalize">{{ task.type || 'N/A' }}</td>
              </tr>
              <tr style="border: solid 1px #dedede;">
                <td class="px-2 py-1 text-capitalize font-bold">Sub Type</td>
                <td class="px-2 py-1 text-capitalize">{{ task.subType || 'N/A' }}</td>
              </tr>
              <tr style="border: solid 1px #dedede;">
                <td class="px-2 py-1 text-capitalize font-bold">Form</td>
                <td class="px-2 py-1 text-capitalize">{{ (form && form.name) || 'N/A' }}</td>
              </tr>
              <tr style="border: solid 1px #dedede;">
                <td class="px-2 py-1 text-capitalize font-bold">Associate Register</td>
                <td class="px-2 py-1 text-capitalize">{{ institutionName || 'N/A' }}</td>
              </tr>
      

              </tbody>
            </table>
          </b-col>
        </b-row>
        <div class="flex gap-2 justify-end pb-2 mt-2" id="action-buttons">
          <button
              class="btn-escalate"
              :disabled="!task"
              @click="escalate"
          >
            <i class="fa fa-arrow-up text-blue mr-1"></i> Escalate
          </button>
          <button
              class="btn-query"
              :disabled="!task"
              @click="query"
          >
            <i class="fa fa-question text-white mr-1"></i> Query
          </button>
          <button
              class="btn-approve"
              :disabled="!task"
              @click="showAreYouSure('approve')"
          >
            <i class="fas fa-check-circle text-white mr-1"></i> Approve
          </button>
        </div>
        <TaskView :id="task.id" />
      </div>
      <div v-else class="flex items-center justify-center flex-1 text-gray-500" style="min-height: 300px;">
        <div class="flex flex-col text-center items-center">
          <i class="fa fa-inbox text-4xl mb-2"></i>
          <label>No tasks available</label>
        </div>
      </div>
    </div>

    <AppModal v-model="showApproveConfirm" xl half>
      <div class="p-6">
        <div class="flex items-start mb-4">
          <div class="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center">
            
          </div>
          <div class="ml-4 flex-1">
            <h3 class="text-xl  text-gray-900 mb-2">Approve Application?</h3>    
        <b-row class="mt-3">
          <b-col cols="4">
            <button class="px-3 py-2 border-2 border-blue bg-white rounded-sm text-blue w-full" @click="showApproveConfirm = false">
              <i class="fa fa-minus-square text-blue mr-2"></i>Cancel</button>
          </b-col>
          <b-col cols="4"></b-col>
          <b-col cols="4">
            <button class="px-3 py-2 bg-green rounded-sm text-white w-full hover:bg-green-dark" @click="showAreYouSure('approve')">
              <i class="fa fa-check-circle text-white mr-1"></i> Approve</button>
          </b-col>
        </b-row>
              
          </div>
        </div>
      </div>
    </AppModal>

  
    <AppModal v-model="showQueryModal" xl half>
      <div class="p-6">
        <!-- <div class="flex items-start mb-4">
          <div class="flex-shrink-0 w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center">
            <i class="fa fa-question-circle text-2xl text-orange-600"></i>
          </div>
          <div class="ml-4 flex-1">
            <h3 class="text-xl font-bold text-gray-900 mb-2">Query Application</h3>
            <div class="text-sm text-gray-600 space-y-2">
              <p class="font-semibold text-gray-800">
                <i class="fa fa-info-circle text-orange-500 mr-2"></i>
                Send a query back to the applicant or previous officer.
              </p>
              <p>Please provide a clear message explaining what needs to be corrected or clarified.</p>
            </div>
          </div>
        </div> -->
        <div class="">
          <label class="block text-sm font-semibold text-gray-700 mb-2">
            Query Message <span class="text-red-500">*</span>
          </label>
          <textarea
              v-model="queryMessage"
              rows="4"
              placeholder="Describe the query you want to raise on this application..."
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 resize-none"
          ></textarea>
        </div>
        <div class="flex gap-3 justify-end mt-6 pt-4 border-t border-gray-200">
     
          <button
              @click="showAreYouSure('query')"
              :disabled="!queryMessage.trim()"
              class="button bg-orange hover:bg-orange-dark text-white rounded-md p-2"
          >
            <i class="fa fa-paper-plane mr-2"></i> Query
            <span class="lds-ring" v-if="querying">
              <div></div><div></div><div></div><div></div>
            </span>
          </button>
        </div>
      </div>
    </AppModal>

    <b-modal id="modal-a-escalate" hide-footer ref="escalateSubmissions" title="Escalate Application">
      <Escalation :taskId="task ? task.id : null" type="nir-affiliations" permission="can_view_non_individual_affiliations_escalations"/>
    </b-modal>

    <AppModal v-model="showFile" xl2>
      <div class="flex flex-col items-center justify-center p-4">
        <div class="bg-white shadow-lg rounded-lg overflow-hidden pdf-frame">
          <iframe
              v-if="fileBytes"
              :src="'data:application/pdf;base64,' + fileBytes + '#toolbar=0&navpanes=0&scrollbar=0'"
              class="w-full h-full border-0 pdf-iframe"
          ></iframe>
        </div>
      </div>
    </AppModal>

    <AppModal v-model="areYouSure" xl half>
      <div class="p-6">
        <div class="flex items-start mb-4">
          
          <div class="ml-4 flex-1">
            
            <b-row>
          <b-col>
            <p class="text-sm">
              <span class="h6">Are you sure you are ready to take this action ?</span>.<br/>
              This action can only be reversed by your superiors. Only confirm if you are certain that this is the appropriate Final Decision
            </p>
            <p class="mt-3 text-sm italic">
              <b>Note:</b><br/>
              All actions performed on <b class="text-blue">URSB eRegistry</b> are recorded and details of the account that initiated are tagged to the action.
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="4">
            <button class="px-3 py-2 border-2 border-blue bg-white rounded-sm text-blue w-full" @click="areYouSure = false">
              <i class="fa fa-minus-square text-blue mr-2"></i>Cancel</button>
          </b-col>
          <b-col cols="4"></b-col>
          <b-col cols="4">
            <button class="px-3 py-2 bg-green rounded-sm text-white w-full hover:bg-green-dark" @click="confirmedToExecuteNextAction">
              <i class="fa fa-check-circle text-white mr-1"></i> Accept</button>
          </b-col>
        </b-row>
              
          </div>
        </div>
      </div>
    </AppModal>
  </div>
</template>

<script>

import jwtService from "../../non-individual/nir/utils/jwt"
import {api} from "../../../../../app/services/api.service";
import AppModal from "../../non-individual/nir/components/AppModal.vue";
import { mapActions, mapGetters } from "vuex";
import TaskView from "../nir/views/AffiliationsTaskView.vue";
import Escalation from "../../../../home/commons/Escalation.vue";

export default {
  name: 'NonIndividualAffiliationsTaskQueue',
  components: {
    TaskView,
    Escalation,
    AppModal },
  data() {
    return {
      loading: true,
      approving: false,
      rejecting: false,
      showApproveConfirm: false,
      showRejectConfirm: false,
      showQueryModal: false,
      showEscalateModal: false,
      showFile: false,
      rejectionReason: '',
      queryMessage: '',
      escalateComment: '',
      fileToView: '',
      fileBytes: '',
      activeTab: 'form',
      task: null,
      form: null,
      formData: null,
      institutions: [],
      querying: false,
      escalating: false,
      selectedRegistrarId: null,
      registrarSearch: '',
      registrarLimit: 15,
      areYouSure: false,
      pendingAction: null,
    };
  },
  computed: {
    ...mapGetters([
      "getRegistrars",
    ]),
    institutionName() {
      if (!this.task || !this.task.institutionId) return 'N/A';
      var inst = (this.institutions || []).find(function (i) { return i.id === this.task.institutionId; }.bind(this));
      return inst ? inst.name : 'N/A';
    },
  },
  mounted() {
    this.fetchInstitutions();
    this.fetch();
  },
  methods: {
    ...mapActions({
      fetchRegistrarsAction: "fetchRegistrars",
      searchRegistrarsAction: "searchRegistrars",
    }),
    fetchInstitutions() {
      var self = this;
      api().get('/nir/api/v1/institutions?page=1&limit=1000')
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.content) {
              self.institutions = res.data.data.content;
            }
          })
          .catch(function () {});
    },
    fetch() {
      var self = this;
      var user = jwtService.getUser();
      var userId = user && user.userId ? user.userId : '';
      this.loading = true;
      api().get('/nir/api/v1/affiliations/next?userId=' + encodeURIComponent(userId))
          .then(function (res) {
            if (res.data && res.data.data) {
              self.task = res.data.data;
              self.fetchForm(self.task.formId);
              self.fetchFormFields(self.task.formId);
            } else {
              self.task = null;
            }
            self.loading = false;
          })
          .catch(function () {
            self.loading = false;
            self.task = null;
          });
      api().get('/nir/api/v1/affiliations/stats').then(function (res) {
        if (res.data && res.data.data) {
          // stats can be stored locally if needed
        }
      });
    },
    fetchForm(formId) {
      var self = this;
      if (!formId) return;
      api().get('/nir/api/v1/configurations/form?id=' + encodeURIComponent(formId))
          .then(function (res) {
            if (res.data && res.data.data) self.form = res.data.data;
          });
    },
    fetchFormFields(formId) {
      var self = this;
      if (!formId) return;
      api().get('/nir/api/v1/configurations/forms/fields?formId=' + encodeURIComponent(formId))
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.data) {
              self.formData = res.data.data.data;
            }
          });
    },
    escalate() {
      this.$refs.escalateSubmissions.show();
    },
    query() {
      this.queryMessage = '';
      this.showQueryModal = true;
    },
    approve() {
      this.showApproveConfirm = true;
    },
    showAreYouSure(action) {
      this.pendingAction = action;
      this.areYouSure = true;
    },
    confirmedToExecuteNextAction() {
      this.areYouSure = false;
      if (this.pendingAction === 'approve') {
        this.confirmApprove();
      } else if (this.pendingAction === 'reject') {
        this.confirmReject();
      } else if (this.pendingAction === 'query') {
        this.confirmQuery();
      }
      this.pendingAction = null;
    },
    reject() {
      this.rejectionReason = '';
      this.showRejectConfirm = true;
    },
    confirmApprove() {
      var self = this;
      this.showApproveConfirm = false;
      this.approving = true;
      api().post('/nir/api/v1/affiliations/approve', { applicationId: this.task ? this.task.id : null })
          .then(function () {
            self.approving = false;
            self.fetch();
          })
          .catch(function () {
            self.approving = false;
          });
    },
  async confirmQuery() {
      if (!this.task || !this.task.id || !this.queryMessage.trim()) return;
      var self = this;
      var senderId = null;
      try {
        const currentUser = JSON.parse(sessionStorage.getItem("current_user") || "{}");
        senderId = currentUser && currentUser.userId ? currentUser.userId : null;
      } catch (e) {
        senderId = null;
      }
      this.querying = true;
      var payload = {
        applicationId: this.task.id,
        message: this.queryMessage.trim(),
      };
      if (senderId) {
        payload.senderId = senderId;
      }
      api().post('/nir/api/v1/affiliations/query', payload)
          .then(function () {
            self.querying = false;
            self.queryMessage = '';
            self.showQueryModal = false;
            self.fetch();
          })
          .catch(function (error) {
            self.querying = false;
            const msg =
              (error && error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
              'Failed to send query. Please try again.';
            if (typeof self.errorToast === 'function') {
              self.errorToast('Query Error', msg);
            }
          });
    },
    confirmReject() {
      var self = this;
      this.showRejectConfirm = false;
      this.rejecting = true;
      api().post('/nir/api/v1/affiliations/approve', {
        applicationId: this.task ? this.task.id : null,
        reason: this.rejectionReason,
      })
          .then(function () {
            self.rejecting = false;
            self.rejectionReason = '';
            self.fetch();
          })
          .catch(function () {
            self.rejecting = false;
          });
    },
    viewFile(fileId) {
      var self = this;
      this.showFile = true;
      this.fileToView = fileId;
      api().post('/nir/api/v1/affiliations/attachment', { fileId: fileId })
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.data) {
              self.fileBytes = res.data.data.data;
            }
          });
    },
    formatDate(dateStr) {
      if (!dateStr) return '—';
      return new Date(dateStr).toLocaleString();
    },
    taskStatusClass(status) {
      var map = {
        PENDING: 'bg-gray-100 text-gray-600',
        SUBMITTED: 'bg-gray-100 text-gray-800',
        ASSIGNED: 'bg-blue text-blue-800',
        APPROVED: 'bg-success-100 text-success-800',
        REJECTED: 'bg-danger-100 text-danger-800',
      };
      return map[status] || 'bg-gray-100 text-gray-600';
    },
    loadRegistrars() {
      // use same permission as route meta for non-individual-affiliations queue
      this.fetchRegistrarsAction({
        permission: "can_view_non_individual_affiliations_tasks",
        limit: this.registrarLimit,
      });
    },
    searchRegistrars() {
      if (!this.registrarSearch || !this.registrarSearch.trim()) {
        this.loadRegistrars();
        return;
      }
      this.searchRegistrarsAction({
        term: this.registrarSearch.trim(),
        permission: "can_view_non_individual_affiliations_tasks",
      });
    },
    statusClass(status) {
      const map = {
        PENDING: 'bg-gray-100 text-gray-600',
        QUERIED: 'bg-orange-100 text-gray-600',
        SUBMITTED: 'bg-gray-100 text-gray-800',
        PREAPPROVAL: 'bg-success-50 text-success-600 border border-success-200',
        ASSIGNED: 'bg-blue-100 text-blue-800',
        APPROVED: 'bg-success-100 text-success-800',
        REJECTED: 'bg-danger-100 text-danger-800',
      };
      return map[status] || 'bg-gray-100 text-gray-600';
    },
  },
};
</script>

<style scoped>
.btn-escalate{
  @apply border border-blue bg-white rounded-sm text-blue text-sm px-3 py-1 mx-1;
}

.btn-escalate:hover{
  @apply text-blue-dark;
}

.btn-approve{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-query{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-reject{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-approve:hover{
  @apply bg-green border-green text-white;
}

.btn-query:hover{
  @apply bg-orange border-orange text-white;
}

.btn-reject:hover{
  @apply bg-red border-red text-white;
}

.flex { display: flex; }
.flex-col { flex-direction: column; }
.p-2 { padding: 0.5rem; }
.details-card { background: white; border-radius: 0.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1); padding: 0.75rem; margin: 0.5rem 0; }
.grid { display: grid; }
.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.gap-4 { gap: 1rem; }
.tab-label { padding: 0.75rem 1.5rem; font-size: 0.875rem; font-weight: 500; border-bottom: 2px solid transparent; cursor: pointer; }
.tab-active { border-color: #2563eb; color: #2563eb; }
.tab-inactive { color: #6b7280; }
.tab-inactive:hover { color: #374151; border-color: #d1d5db; }
.badge-count { background: #dbeafe; color: #1e40af; font-size: 0.75rem; font-weight: 500; padding: 0.125rem 0.5rem; border-radius: 9999px; }
.attachments-card { background: white; border-radius: 0.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1); padding: 1.5rem; }
.attachment-item { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 0.5rem; padding: 1rem; cursor: pointer; }
.attachment-item:hover { box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); }
.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
.md-grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.pdf-frame { width: 595px; height: 842px; }
.pdf-iframe { width: 595px; height: 842px; }
.min-h-screen { min-height: 100vh; }
.animate-pulse { animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
.lds-ring { display: inline-block; position: relative; width: 20px; height: 20px; vertical-align: middle; margin-left: 8px; }
.lds-ring div { box-sizing: border-box; display: block; position: absolute; width: 16px; height: 16px; margin: 2px; border: 2px solid currentColor; border-radius: 50%; animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite; border-color: currentColor transparent transparent transparent; }
.lds-ring div:nth-child(1) { animation-delay: -0.45s; }
.lds-ring div:nth-child(2) { animation-delay: -0.3s; }
.lds-ring div:nth-child(3) { animation-delay: -0.15s; }
@keyframes lds-ring { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
</style>
